import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDriveit} from '../../api/api.js';
import FlatList from 'flatlist-react';
import DrawerNavigation from '../../utils/DrawerNavigation.js';
import { useMediaQuery } from 'react-responsive';
import { VscMenu } from "react-icons/vsc";
import myinventory from '../../assets/myinventory-logo.svg';
import myinventoryIcone from '../../assets/myinventory-icone.svg';
import atos from '../../assets/atos-logo.svg';
import usuario from '../../assets/usuario.svg';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';

function PerfisDeUsuario() {
    const navigate = useNavigate();
    const location = useLocation();
    const [users, setUsers] = useState([]);
    const user = location.state?.user || localStorage.getItem('user');
    const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
    useEffect(() => {
        if (user === undefined) {
            navigate('/myinventory/');
            // eslint-disable-line react-hooks/exhaustive-deps  
        }
    }, [user]);
    const [searchValue, setSearchValue] = useState("");

    //Função assíncrona para buscar os usuários
    const fetchUsers = async () => {
        const response = await getDriveit();
        setUsers(response.map((r) => r.fields));
    };
    useEffect(() => {
        if (!users || users.length === 0) {
            fetchUsers();
        }
    }, []);

    const renderItem = (user, index) => (
        <div className='div-perfis-de-usuario centralizar' onClick={() => navigate('/myinventory/EditarPerfisDeUsuario', { state: { user: user } })} key={user.dasId}>
            

            <div>
                <p style={{ textTransform: 'capitalize' }}>Nome: {user.nome} {user.sobrenome}</p>{" "}
                <p style={{ textTransform: 'capitalize' }}>{user.roles}</p>
            </div>

        </div>
    );

    return (
        <>
            <DrawerNavigation />
            <header>
                {isBigScreen && <img src={myinventory} alt="logo myinventory" className='myinventory-logo' onClick={() => navigate('/myinventory/OpcoesDeAcesso', { state: { user } })} />}
                {!isBigScreen && <img src={myinventoryIcone} alt="logo myinventory" className='myinventory-icone' onClick={() => navigate('/myinventory/OpcoesDeAcesso', { state: { user } })} />}
            </header>
            <main>
                <p className="texto-principal-da-pagina">Selecione o usuário para editar o perfil</p>
                <form
                    style={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'center' }}

                >
                    <input
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value.toLocaleLowerCase())}
                        className="input-login"
                        type="text"
                        id="nickName"
                        placeholder="  Pesquisar usuários..."
                    />
                </form>
                
                <FlatList
                    list={users}
                    searchBy={["dasId", "nome", "sobrenome", "email"]}
                    searchTerm={searchValue}
                    searchCaseInsensitive
                    renderItem={renderItem}
                    renderWhenEmpty={() => <div>Não há usuários cadastrados!</div>}
                />
                
                <footer>
                    <img src={atos} className='footer-alinhamento Atos-logo' alt='logo atos'></img>
                </footer>

            </main>
        </>
    );
}

export default PerfisDeUsuario;